import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class VehicleChargeComponent implements IController {
  program: any;
  groups: any;
  programId: any;
  accountId: any;

  public isUseVehicleLegacy: boolean;

  $onInit() {
    this.isUseVehicleLegacy = this.groups.some(group => group === 'VehicleFactor');
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanVehicleChargeView', {
    bindings: {
      program: '<',
      groups: '<',
      programId: '<',
      accountId: '<?'
    },
    template: require('./vehicle-charge.html').default,
    controller: VehicleChargeComponent
  });
